// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605200803/js/" + chunkId + "." + {"44":"9b8b57d3","225":"cf5d7de0","481":"4629a452","486":"ba758522","770":"4231dbd3"}[chunkId] + ".0.3526773775043601.chunk.js";
};